module.exports = __webpack_public_path__ + "img/ROHS.d547e56f.jpg";